import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import './PatientNotesHeaderActions.css';

const PatientNotesHeaderActions = ({ onAddMessage, onAddOperation, onAddNote, doctorId }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    
    const showMessageOption = typeof onAddMessage === 'function';
    const showOperationOption = typeof onAddOperation === 'function';
    const hasDropdownOptions = showMessageOption || showOperationOption;

    const handleMessagesClick = () => {
        navigate(`/control/patients/${id}/messages`);
    };

    return (
        <div className="d-flex justify-content-between align-items-center mb-3 patient-notes-header">
            <h4 className="mb-0">Patient Visits</h4>
            <div className="d-flex align-items-center gap-2">
                <button
                    type="button"
                    className="control-btn add-note-btn"
                    onClick={onAddNote}
                    title="Add new appointment"
                >
                    <i className="fas fa-plus"></i>
                </button>
                
                {hasDropdownOptions && (
                    <Dropdown show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)} align="end">
                        <Dropdown.Toggle 
                            as="button"
                            className="more-actions-btn control-btn"
                            title="More actions"
                            bsPrefix="custom"
                        >
                            <i className="fas fa-ellipsis-v"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="modern-dropdown-menu">
                            {showOperationOption && (
                                <Dropdown.Item 
                                    onClick={() => {
                                        onAddOperation();
                                        setShowDropdown(false);
                                    }}
                                    className="dropdown-item-modern"
                                >
                                    <i className="fas fa-syringe me-2"></i>
                                    Add Operation
                                </Dropdown.Item>
                            )}
                            {showMessageOption && (
                                <Dropdown.Item 
                                    onClick={() => {
                                        onAddMessage();
                                        setShowDropdown(false);
                                    }}
                                    className="dropdown-item-modern"
                                >
                                    <i className="fas fa-comment me-2"></i>
                                    Send WhatsApp Message
                                </Dropdown.Item>
                            )}
                            <Dropdown.Item 
                                onClick={() => {
                                    handleMessagesClick();
                                    setShowDropdown(false);
                                }}
                                className="dropdown-item-modern"
                            >
                                <i className="fas fa-comments me-2"></i>
                                View Messages
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
        </div>
    );
};

export default PatientNotesHeaderActions;
